  // export const BASE_URL = 'http://192.168.1.228:5000';

  //export const BASE_URL = 'http://192.168.1.156:5000';

   export const BASE_URL = 'https://seataxibackend.seataxi.in';

